import { ROLE_LABEL } from '@app/shared/core';
import { Logo } from '../brand/Logo';
import { useApp } from '../state';

/** Шапка вкладок: логотип и кто вошёл. */
export function TopBar() {
  const { me } = useApp();
  const e = me.employee;
  return (
    <header className="topbar">
      <Logo height={14} />
      {e && (
        <div className="who">
          <div className="ellipsis" style={{ maxWidth: 180 }}>{e.fullName}</div>
          {e.role && <div>{ROLE_LABEL[e.role]}</div>}
        </div>
      )}
    </header>
  );
}
